// 直接调用spacebase的接口
let paths = [
	'/admin/address/exportApartmentsInBuilding',
	'/admin/address/addPinYinNamespaceAddressToken',
	'/admin/address/checkEditAddressPrivilege',
	'/admin/address/correctAddress',
	'/admin/address/importAddressInfos',
	'/admin/address/importAddressData',
	'/admin/address/importParkAddressData',
	'/admin/address/syncThirdAddresses',
	'/admin/address/syncTableAddress',
	'/admin/address/listAddressConfigurations',
	'/admin/address/updateAddressConfigurations',
	'/admin/community/deleteAddressRoomFunction',
	'/admin/community/updateAddressRoomFunction',
	'/admin/community/createAddressRoomFunction',
	'/admin/community/listAddressRoomFunction',
	'/admin/community/getAddressRoomFunction',
	'/admin/community/listAddressHouseType',
	'/admin/community/getAddressHouseType',
	'/admin/community/deleteAddressHouseType',
	'/admin/community/updateAddressHouseType',
	'/admin/community/createAddressHouseType',
	'/admin/address/initAddressOccupationTimeTables',
	'/admin/address/fixAddressTimeOccupation',
	'/pm/createOrUpdateOtherLivingStatusNameConfig',
	'/pm/fixApartmentLivingStatusByNamespaceId',
	'/pm/listApartmentsByMultiStatusWithoutAuth',
	'/pm/listApartmentsByMultiStatus',
	'/pm/hasApartmentManagementPrivilege',
	'/pm/ReservationExpireCheckRunning',
	'/pm/getApartmentDetailWithOutAuth',
	'/pm/hasLookApartmentPrivilege',
	'/pm/listPropApartmentsByKeywordWithoutAuth',
	'/pm/listPropApartmentsByKeyword',
	'/pm/listPropBuildingsByKeyword',
	'/pm/getNewApartmentStatistics',
	'/pm/listPropApartmentsV2',
	'/pm/fixApartmentLivingStatus',
	'/pm/listApartmentsForApp',
	'/pm/listApartmentsInBuilding',
	'/pm/createApartment',
	'/pm/updateApartment',
	'/pm/findReservations',
	'/pm/listReservations',
	'/pm/listApartmentEvents',
	'/pm/createReservation',
	'/pm/updateReservation',
	'/pm/deleteReservation',
	'/pm/cancelReservation',
	'/pm/getApartmentDetail',
	'/pm/deleteApartment',
	'/pm/listPropApartments',
	'/pm/listApartments',
	'/pm/getApartmentStatistics',
	'/pm/setApartmentStatus',
	'/pm/importPMAddressMapping',
	'/pm/listPMAddressMapping',
	'/admin/community/exportDynamicApartmentsWithoutData',
	'/admin/community/getImportCommunityApartmentsTemplateV2',
	'/admin/community/exportApartmentsInCommunity',
	'/admin/community/importFastApartmentsData',
	'/admin/community/exportDynamicApartments',
	'/admin/community/tempImportApartmentsData',
	'/admin/community/importApartmentsData',
	'/address/createAddressArrangement',
	'/address/listAddressArrangement',
	'/address/updateAddressArrangement',
	'/address/deleteAddressArrangement',
	'/address/excuteAddressArrangement',
	'/address/uploadApartmentAttachment',
	'/address/deleteApartmentAttachment',
	'/address/downloadApartmentAttachment',
	'/address/listApartmentAttachments',
	'/address/dataMigrationAddressVarFieldScopeByRoomFunctionAllNamespace',
	'/address/dataMigrationAddressVarFieldScopeByRoomFunction',
	'/address/listApartmentsByBuildingName',
	'/address/listApartmentsByBuildingId',
	'/address/getApartmentByBuildingApartmentName',
	'/address/getApartmentByBuildingApartmentId',
	'/address/getApartmentByBuildingIdAndApartmentName',
	'/address/listUnassignedApartmentsByBuildingName',
	'/address/listUnassignedApartmentsByBuildingId',
	'/address/listCommunityApartmentsByBuildingName',
	'/address/listCommunityApartmentsByBuildingId',
	'/address/getApartmentNameByBuildingName',
	'/address/getApartmentNameByBuildingId',
	'/address/listApartmentEnterpriseCustomers',
	'/address/fixInvalidCityInAddresses',
	'/address/getImportCommunityApartmentsTemplate',
	'/address/getImportBuildingApartmentsTemplate',
	'/address/getAddressSignContractStartTime',
	'/address/exportApartmentsQRCodeInBuilding',
	'/address/exportApartmentsQRCodeInCommunity',
	'/address/listAddressShopFormsByDatas',
	'/address/listAddressShopCategoriesByDatas',
	'/address/dataMigrationAddressBusinessTag',
	'/address/dataMigrationAddressByRoomfunction',
	'/address/countAddressByRoomFunctionId',
	'/address/listBuildingFieldsByCommunitiyIds',
	'/address/getAddressByRoomFunctions',
	'/address/getAddressOrientationNames',
	'/address/listApartmentsByKeyword',
	'/address/listAddressByKeyword',
	'/address/updateAddressAreaSize',
	'/address/listAddressByIds',
	'/address/listSpaceStations',
	'/address/createSpaceStation',
	'/address/updateSpaceStation',
	'/address/getStationInfoDetail',
	'/address/deleteSpaceStation',
	'/address/importStationData',
	'/address/exportStationsInSpace',
	'/address/listAddressWithPropByIds',
	'/address/getAddressAppId',
	'/address/listApartmentCustomers',
	'/address/getRoomFunctions',
	'/address/getAddressCompleteInfo',
	'/address/getAddressSimpleInfos',
	'/address/getAddressFunctionNames',
	'/address/getAddressTypeItemNames',
	'/address/listApartmentByCrmId',
	'/address/listSectionByBuildingId',
	'/address/listSimpleApartmentInfo',
	'/address/testCreamsApi',
	'/address/listAddressFormats',
	'/address/repairAddressStatus',
	'/address/dataMigrateForHistoryAddress',
	'/address/getHistoryApartment',
	'/address/createHistoryApartment',
	'/address/updateHistoryApartment',
	'/address/deleteHistoryApartment',
	'/community/listAddressHouseTypeByDatas',
	'/community/listAddressRoomFunctionByDatas',
	'/community/getCommunityCustomizeStatistic',
	'/community/getAllCommunityCustomizeStatisticInDB',
	'/community/getCommunityRateStatistic',
	'/community/getCommunityTrendsStatistic',
	'/community/getApartmentRateStatistic',
	'/community/createOrUpdateStatisticalRule',
	'/community/createStatisticalTerm',
	'/community/getStatisticalTerm',
	'/community/statisticalSchedule',
	'/community/getBuildingRateStatistic',
	'/community/getStatisticalRule',
	'/address/addOrUpdateAddressTagGroup',
	'/address/listAddressTags',
	'/address/addOrUpdateAddressTag',
	'/address/deleteAddressTag',
	'/address/listAddressTagGroups',
	'/address/deleteAddressTagGroup',
	'/address/setTagGroup',
	'/address/setAddressTag',
	'/address/unSetAddressTag',
	'/address/getAddressTag',
	'/address/getTagTree',
	'/address/listAddressTimeOccupations',
	'/address/createAddressTimeOccupation',
	'/address/updateAddressTimeOccupation',
	'/community/deleteAddressTimeOccupation',
	'/community/getAllCommunityCustomizeStatistic',
	'/community/importSpaceAndStationData',
	'/community/listAddressLivingStatusByDatas',
	'/community/paddingAllBuildingFloorStartAndEndNumber',
	'/community/getBuildingStatisticsForApp',
	'/community/getCommunityApartmentsStatistic',
	'/community/listApartmentsInCommunityWithoutAuth',
	'/community/listApartmentsInCommunity',
	'/community/listAllBuildingFloorNames',
	'/community/exportSpaceByKeywords',
	'/community/getAddressNum',
	'/community/exportSpaceAndStations',
	'/community/checkCommunityPrivilege',
	'/community/importSpaceData',
	'/community/deleteSpace',
	'/community/createOrUpdateSpace',
	'/community/listSpacesByKeywords',
	'/community/paddingBuildingFloor',
	'/community/paddingAllBuildingFloor',
	'/community/listBuildingsForApp',
	'/community/caculateGeoHash',
	'/community/caculateAllBuildingArea',
	'/community/caculateBuildingArea',
	'/community/changeBuildingOrder',
	'/community/getFloorRange',
	'/community/listCommunityApartments',
	'/community/getBuildingStatistics',
	'/community/listBuildingsByKeywords',
	'/community/getBuilding',
	'/community/listBuildingsWithoutAuth',
	'/community/listBuildings',
	'/community/getBuildingsByCommunity',
	'/community/syncBuildings',
	'/community/listBuildingDTOByKey',
	'/community/listAllBuildingSections',
	'/community/initCommunityProvinces',
	'/community/getCommunitiesLocation',
	'/community/getSpace',
	'/openapi/address/listFloors',
	'/openapi/address/getApartmentByPropertyNo',
	'/openapi/address/listApartments',
	'/openapi/address/listBuildings',
	'/address/openapi/listAddresses',
	'/propertyNo/generateBuildingPropertyNo',
	'/propertyNo/generateAddressPropertyNo',
	'/propertyNo/getPropertyNoConfig',
	'/propertyNo/propertyNoSwitch',
	'/propertyNo/updatePropertyNoConfig',
	'/admin/community/getImportBuildingDataTemplateV2',
	'/admin/community/populateTablesNamespaceIdAndCid',
	'/admin/community/exportBuildingByCommunityId',
	'/admin/community/getImportBuildingDataTemplate',
	'/admin/community/listBuildingTree',
	'/admin/community/importFastBuildingData',
	'/admin/community/deleteBuilding',
	'/admin/community/verifyBuildingName',
	'/admin/community/listBuildingsByStatus',
	'/admin/community/approveBuilding',
	'/admin/community/rejectBuilding',
	'/admin/community/updateBuildingOrder',
	'/admin/community/importBuildingData',
	'/admin/community/exportBuildingByKeywords',
	'/admin/community/updateBuilding',
	'/admin/community/createBuildingArea',
	'/admin/community/deleteBuildingArea',
	'/admin/community/updateBuildingArea',
	'/admin/community/listBuildingArea',
	'/admin/community/getBuildingArea',
	'/admin/community/listBuildingType',
	'/admin/community/getBuildingType',
	'/admin/community/deleteBuildingType',
	'/admin/community/updateBuildingType',
	'/admin/community/createBuildingType',
	'/community/listBuildingArea',
	'/building/dataMigrationBuildingByBuildingType',
	'/building/listBuildingsByCommunityId',
	'/building/createVendorBuildingFloors',
	'/building/listBuildingForPublicComponent',
	'/building/listBuildingsByKeyword',
	'/building/listBuildingByCrmId',
	'/building/listBuildings',
	'/address/listAllApartmentsOfAFloor',
	'/address/listFloorsOfMultiBuildings',
	'/address/listFloorsOfABuilding',
	'/address/listApartmentsOfAFloor',
	'/address/updateBuildingFloor',
	'/address/listFloorByBuildingId',
	'/building/listBuildingPassengers',
	'/building/getBuildingPassenger',
	'/building/deleteBuildingPassenger',
	'/building/updateBuildingPassenger',
	'/building/createBuildingPassenger',
	'/community/listBuildingTypeByDatas',
	'/customer/createOrUpdateCrmTagGroup',
	'/customer/deleteCrmTagGroup',
	'/customer/listCrmTagGroups',
	'/customer/createOrUpdateCrmTag',
	'/customer/deleteCrmTag',
	'/customer/moveCrmTags',
	'/customer/listCrmTags',
	'/customer/setCrmTag',
	'/customer/batchSetCrmTags',
	'/customer/unsetCrmTags',
	'/customer/getCustomerTags',
	'/customer/getCustomerRiskTags',
	'/customer/getCustomersByTags',
	'/customer/getTagTree',
	'/customer/listAllOrganizationMemberWithCrmV2Customer',
	'/customer/batchDeleteCrmV2CustomerUserByOrgMemberId',
	'/customer/autoSyncCreamsSyncCustomers',
	'/customer/batchSyncThirdCustomerInfo',
	'/customer/getSpaceUserGroupByOwnerId',
	'/customer/searchEnterpriseCustomerWithoutAuth',
	'/customer/crmV2EnterpriseCustomerRelations',
	'/customer/crmV2IndividualCustomerRelations',
	'/customer/listCrmV2AlikeEnterprises',
	'/customer/exportCrmV2EnterpriseTemplate',
	'/customer/exportCrmV2BusinessInfoTemplate',
	'/customer/exportCrmV2IndividualTemplate',
	'/customer/importCrmV2CustomerCommunityEntryInfos',
	'/customer/getCrmV2EnterpriseByOrganizationId',
	'/customer/getThirdEnterpriseNameListByKeyword',
	'/customer/getThirdEnterpriseNameListByKeywordV2',
	'/customer/getFollowWithCrmV2CustomerAndUser',
	'/customer/updateCustomerShareholderInfo',
	'/customer/listCustomerShareholderInfo',
	'/customer/deleteCustomerShareholderInfo',
	'/customer/updateCustomerEconomicIndicator',
	'/customer/listCustomerEconomicIndicator',
	'/customer/createCrmV2IndividualResident',
	'/customer/updateCrmV2IndividualResident',
	'/customer/deleteCrmV2IndividualResident',
	'/customer/listCrmV2IndividualResident',
	'/customer/importCrmV2CustomerCruxUsers',
	'/customer/updateCrmV2CustomerUserForSquare',
	'/customer/updateCustomerProprietaryCompany',
	'/customer/listCustomerProprietaryCompany',
	'/customer/deleteCustomerProprietaryCompany',
	'/customer/updateCustomerOutboundInvestment',
	'/customer/listCustomerOutboundInvestment',
	'/customer/deleteCustomerOutboundInvestment',
	'/customer/updateCustomerUltimateBeneficiary',
	'/customer/listCustomerUltimateBeneficiary',
	'/customer/deleteCustomerUltimateBeneficiary',
	'/customer/updateCustomerFinancingProcess',
	'/customer/listCustomerFinancingProcess',
	'/customer/deleteCustomerFinancingProcess',
	'/customer/updateCustomerAdministrativeLicense',
	'/customer/listCustomerAdministrativeLicense',
	'/customer/deleteCustomerAdministrativeLicense',
	'/customer/autoUpdateCustomerRiskLabel',
	'/customer/getEnterpriseCreditReport',
	'/customer/updateCustomerCompanyYearReport',
	'/customer/listCustomerCompanyYearReport',
	'/customer/deleteCustomerCompanyYearReport',
	'/customer/listNowCustomerEntryInfos',
	'/customer/createCustomerAffiliation',
	'/customer/deleteCustomerAffiliation',
	'/customer/listCustomerForAffiliation',
	'/customer/batchCreatePropertyAttachment',
	'/customer/listCustomerAffiliationForPayment',
	'/customer/getLivingCustomerByAddressId',
	'/customer/listNonContactsCustomerForPayment',
	'/customer/postCustomerMaintainValue',
	'/customer/approvalCustomerMaintainValue',
	'/customer/listCustomerMaintainValue',
	'/customer/updateCustomerMaintainValue',
	'/customer/settingCrmCustomerShowInfoFlag',
	'/customer/syncCrmV2EnterprisesByYonyou',
	'/customer/updateCrmV2Enterprise',
	'/customer/createCrmV2Enterprise',
	'/customer/getCrmV2CustomerUser',
	'/customer/entryCrmV2Community',
	'/customer/createCrmV2EntryInfo',
	'/customer/updateCrmV2Individual',
	'/customer/createCrmV2Individual',
	'/customer/listCrmV2Individuals',
	'/customer/outCrmV2Community',
	'/customer/listCrmV2Communities',
	'/customer/listCrmV2AlikeIndividuals',
	'/customer/getCrmV2Enterprise',
	'/customer/deleteCrmV2Enterprise',
	'/customer/getCrmV2Individual',
	'/customer/deleteCrmV2Individual',
	'/customer/updateCrmV2EntryInfo',
	'/customer/listCrmV2EntryInfos',
	'/customer/listExitCrmV2EntryInfos',
	'/customer/outCrmV2EntryInfo',
	'/customer/deleteCrmV2EntryInfo',
	'/customer/batchExitCrmV2EntryInfo',
	'/customer/importCrmV2BusinessInfo',
	'/customer/exportCrmV2Enterprises',
	'/customer/exportCrmV2Individuals',
	'/customer/importCrmV2Customer',
	'/customer/followCrmV2Customer',
	'/customer/getSyncApiDataReflectMap',
	'/customer/updateCustomerCoreTeam',
	'/customer/listCustomerCoreTeam',
	'/customer/deleteCustomerCoreTeam',
	'/customer/createCrmV2CustomerUser',
	'/customer/listCrmV2CustomerUser',
	'/customer/updateCrmV2CustomerUser',
	'/customer/deleteCrmV2CustomerUser',
	'/customer/exchangeCrmV2SysAdmin',
	'/customer/deleteCrmV2SysAdmin',
	'/customer/createCrmV2SysAdmin',
	'/customer/listCrmV2SysAdmins',
	'/customer/importCrmV2CustomerUsers',
	'/customer/updateCustomerTaxRating',
	'/customer/listCustomerTaxRating',
	'/customer/deleteCustomerTaxRating',
	'/customer/updateCustomerBidding',
	'/customer/listCustomerBidding',
	'/customer/deleteCustomerBidding',
	'/customer/updateCustomerBrandInfo',
	'/customer/listCustomerBrandInfo',
	'/customer/deleteCustomerBrandInfo',
	'/customer/updateCustomerBranchOrg',
	'/customer/listCustomerBranchOrg',
	'/customer/listCustomerEntryInfos',
	'/customer/listCustomerAffiliation',
	'/customer/createPropertyAttachment',
	'/customer/deletePropertyAttachment',
	'/customer/listPropertyAttachment',
	'/customer/listHolderChangeInfos',
	'/customer/confirmHolderChangeInfo',
	'/customer/exportHolderChangeInfos',
	'/customer/fetchHolderChangeInfo',
	'/customer/getCrmV2Fields',
	'/customer/listCustomersForPayment',
	'/customer/updateCrmV2InvoiceInfos',
	'/customer/getCustomerMaintainValue',
	'/customer/postCrmEnterpriseInfo',
	'/customer/settingCrmEnterpriseInfo',
	'/customer/listResidentIntoApartments',
	'/customer/getCrmEnterpriseInfo',
	'/customer/takeThumbEnterpriseInfo',
	'/customer/checkCrmV2InvoiceInfos',
	'/customer/manualExpireEntryInfo',
	'/customer/exportData',
	'/customer/syncCrmV2ByJinKong',
	'/customer/syncCustomerToTefangEAS',
	'/customer/kingdeeCustomerUpdate',
	'/customer/fttkUpdate',
	'/customer/getAssetCustomer',
	'/customer/syncThirdCustomerInfo',
	'/customer/getSyncResult',
	'/customer/listCrmRentalBills',
	'/customer/getAuthorizedOperationIds',
	'/customer/updateSpaceUserGroup',
	'/customer/tlwyCrmSyn',
	'/customer/exportCrmV2BusinessInfo',
	'/customer/syncCustomerIndex',
	'/customer/getAllURL',
	'/customer/listCrmV2Enterprises',
	'/customer/exportCrmV2TrackingTemplate',
	'/customer/settingCrmV2Trackers',
	'/customer/createCrmV2Tracking',
	'/customer/deleteCrmV2Tracking',
	'/customer/listCrmV2Tracking',
	'/customer/importCrmV2Tracking',
	'/customer/listCustomerTrackings',
	'/customer/getCustomerTracking',
	'/customer/updateCustomerTracking',
	'/customer/deleteCustomerTracking',
	'/customer/createCustomerTracking',
	'/customer/createCustomerCertificate',
	'/customer/updateCustomerCertificate',
	'/customer/deleteCustomerCertificate',
	'/customer/getCustomerCertificate',
	'/customer/listCustomerCertificate',
	'/customer/listCustomerEconomicIndicators',
	'/customer/createCustomerEconomicIndicator',
	'/customer/deleteCustomerEconomicIndicator',
	'/customer/getCustomerEconomicIndicator',
	'/customer/updateCustomerEconomicIndicator',
	'/customer/listCustomerEntryInfosWithoutAuth',
	'/customer/createCustomerEntryInfoList',
	'/customer/getCustomerEntryInfo',
	'/customer/createCustomerEntryInfo',
	'/customer/deleteCustomerEntryInfo',
	'/customer/updateCustomerEntryInfo',
	'/customer/listCustomerEvents',
	'/customer/updateCustomerLawsuit',
	'/customer/deleteCustomerLawsuit',
	'/customer/listCustomerLawsuit',
	'/customer/createCustomerPatent',
	'/customer/updateCustomerPatent',
	'/customer/updateCustomerPatentInfo',
	'/customer/deleteCustomerPatent',
	'/customer/getCustomerPatent',
	'/customer/listCustomerPatentInfo',
	'/customer/deleteCustomerPatentInfo',
	'/customer/createCustomerPropertyConfig',
	'/customer/getCustomerPropertyConfigByName',
	'/customer/updateCustomerPropertyConfig',
	'/customer/getCustomerPropertyRightNumber',
	'/customer/updateCustomerPropertyRightNumber',
	'/customer/listCustomerPropertyRightNumber',
	'/customer/deleteCustomerPropertyRightNumber',
	'/customer/getCustomerPropertyRightOthers',
	'/customer/updateCustomerPropertyRightOthers',
	'/customer/listCustomerPropertyRightOthers',
	'/customer/deleteCustomerPropertyRightOthers',
	'/customer/updateCustomerQualAuth',
	'/customer/getCustomerQualAuth',
	'/customer/listCustomerQualAuth',
	'/customer/deleteCustomerQualAuth',
	'/customer/batchCreateCrmResidentCars',
	'/customer/listApartmentCustomerCars',
	'/customer/updateCrmResidentCar',
	'/customer/deleteCrmResidentCar',
	'/customer/listCrmResidentCars',
	'/customer/getCustomerSoftwareCopyright',
	'/customer/listCustomerSoftwareCopyright',
	'/customer/updateCustomerSoftwareCopyright',
	'/customer/deleteCustomerSoftwareCopyright',
	'/customer/createCustomerTalent',
	'/customer/updateCustomerTalent',
	'/customer/deleteCustomerTalent',
	'/customer/getCustomerTalent',
	'/customer/listCustomerTalent',
	'/customer/listCustomerTrackingPlansByDate',
	'/customer/listCustomerTrackingPlans',
	'/customer/updateCustomerTrackingPlan',
	'/customer/deleteCustomerTrackingPlan',
	'/customer/createCustomerTrackingPlan',
	'/customer/getCustomerTrackingPlan',
	'/customer/createCustomerTrademark',
	'/customer/updateCustomerTrademark',
	'/customer/deleteCustomerTrademark',
	'/customer/getCustomerTrademark',
	'/customer/listCustomerTrademark',
	'/openapi/customer/listCustomers',
	'/dynamicHeader/listAllDynamicHeaderFields',
	'/dynamicHeader/updateCustomerFieldSettings',
	'/statistics/dataMigrateStatusChangeLog',
	'/statistics/getNewAreaSizeBetweenTime',
	'/statistics/getStatisticConfig',
	'/statistics/updateStatisticConfig',
	'/statistics/getFirstLogCreateTime',
	'/customer/vendor/listVendorParams',
	'/customer/vendor/listVendors',
	'/customer/vendor/initVendorParam',
	'/customer/vendor/initVendor',
	'/customer/vendor/updateVendorParams',
	'/vendor/listSystemCreditInfoVendor',
	'/vendor/listNamespaceEnableVendor',
	'/vendor/settingNamespaceVendorConfig',
	'/vendor/listSystemCreditInfoVendorApi',
	'/vendor/listCreditInfoVendorApiScope',
	'/vendor/getGeneralFormBusinessCustomItem',
	'/vendor/syncApiData',
	'/vendor/getVendorScope',
	'/vendor/getNamespaceVendorConfig',
	'/vendor/enableVendorScope',
	'/vendor/enableNamespaceVendor',
	'/vendor/saveVendorApiScope',
	'/vendor/listSystemVendorApiParam',
	'/vendor/listVendorApiParamScope',
	'/vendor/saveVendorApiParamScope',
	'/vendor/tryToConnect',
	'/vendor/getVendorRecord'
];
/**
 * 根据请求路径名及传参moduleName，返回service
 * @param {Object} params - 包含传参 路径名
 * @return {Sring} service
 */
export const intercept = params => {
	let { service, api, data = {} } = params;
	if (service && service.indexOf('/') === -1) {
		service = '/' + service
	}
	// const path = api;
	const path = pathReplace(api);
	if (paths.includes(path)) return '/spacebase';
	// 判读路径名是否包含varField
	if (path.indexOf('/varField/') == -1) return (typeof service === 'undefined') ? '/evh' : service;
	if (!Object.prototype.hasOwnProperty.call(data, 'moduleName')) {
		console.error(`接口${api}请求参数没有moduleName`);
		return '/evh';
	} else {
		if (service) return service;
		const propertymgrArr = [
			'asset_addressinfo',
			'contract',
			'enterprise_customer',
			'equipment_inspection',
			'investment_ad',
			'investment_room',
			'investment_shop',
			'nonbuilding_asset',
			'paymentContract',
			'pay_contract',
			'point_asset',
			'shop_addressinfo'
		];
		const spacebaseArr = [
			'crm_v2',
			'crm_v2_enterprise',
			'crm_v2_individual',
			'building_asset',
			'nonbuilding_asset',
			'crm_enterprise',
			'room_asset',
			'asset_business_tag',
			'enterprise_customer',
			'crm_enterprise'
		];
		const { moduleName } = data;
		if (propertymgrArr.includes(moduleName)) return '/propertymgr';
		if (spacebaseArr.includes(moduleName)) return '/spacebase';
		console.error(`接口${api}请求参数的moduleName值为${moduleName}!`);
		return '/evh';
	}
};

// 路径替换 判断路径名是否包含/propertymgr，且属于paths，有则删除 历史遗留问题
export const pathReplace = api => {
	// 下面几个接口地址不变
	const arr = [
		'/propertymgr/dynamicHeader/listDynamicHeaderFields',
		'/propertymgr/dynamicHeader/listAllDynamicHeaderFields',
		'/propertymgr/dynamicHeader/updateDynamicHeaderFields',
		'/propertymgr/dynamicHeader/listCustomerFieldSettings'
	];
	if (arr.includes(api)) return api;
	const path = api.replace('/propertymgr', '');
	return paths.includes(path) ? path : api;
};

